__turbopack_context__.v({
  "show_grid": "ShowGrid-module-scss-module__2YqpJW__show_grid",
  "show_grid__card": "ShowGrid-module-scss-module__2YqpJW__show_grid__card",
  "show_grid__poster": "ShowGrid-module-scss-module__2YqpJW__show_grid__poster",
  "show_grid__show_poster": "ShowGrid-module-scss-module__2YqpJW__show_grid__show_poster",
  "show_grid_link_button": "ShowGrid-module-scss-module__2YqpJW__show_grid_link_button",
  "show_grid_wrapper": "ShowGrid-module-scss-module__2YqpJW__show_grid_wrapper",
});
